const e=e=>{global.innerWidth=e,window.dispatchEvent(new Event("resize"))},n=e=>{global.innerHeight=e,window.dispatchEvent(new Event("resize"))};export{n as resizeWindowHeightTestUtil,e as resizeWindowWidthTestUtil};
